import { useContext } from 'react'
import { UserContext } from '@/store/userStore'

export const useUserStore = () => {
  const context = useContext(UserContext)
  if (!context) {
    throw new Error('useUserStore must be used within a UserContext.Provider')
  }
  return context
}
